/* eslint-disable @typescript-eslint/no-explicit-any */
import { Link } from "react-router-dom";
import { FaUserTie, FaHardHat, FaChartLine } from "react-icons/fa";
import { RiAdminFill, RiShieldUserFill } from "react-icons/ri";
import { IconWrapper } from "../../customHooks/useIcon";
import { IUser } from "../../utils/interfaces";
import { ROLE } from "../../utils/constants";
import { useUtils } from "../../customHooks/useUtils";

function UserTypeSwitcher({ userInfo, company_id }: { userInfo: IUser, company_id: string }) {
  const { t } = useUtils();
  return (
    <div className="flex flex-col items-center justify-center mt-10  bg-[#FDFDFD] gap-4 p-8 rounded-[20px] border border-[#77777733] min-h-[250px] max-w-[850px] mx-auto">
      <h2 className="lg:self-start text-2xl font-semibold text-gray-700">
        {`${t("greetings.welcome")} ${userInfo?.first_name}!`}
      </h2>

      {/* Permission Options */}
      <div className="mt-8 flex gap-6 flex-wrap justify-center lg:justify-start w-full">
        <PermissionCard
          title={t("role.manager")}
          icon={<IconWrapper icon={FaUserTie} size={40} />}
          bgColor="bg-primary-yellowMain"
          to={`/dashboard/senior-manager/home/${company_id}`}
        />
        <PermissionCard
          title={t("role.operations")}
          icon={<IconWrapper icon={FaHardHat} size={40} />}
          bgColor="bg-primary-yellowMain"
          to={`/dashboard/operations/home/${company_id}`}
        />
        <PermissionCard
          title={t("role.finance")}
          icon={<IconWrapper icon={FaChartLine} size={40} />}
          bgColor="bg-primary-yellowMain"
          to={`/dashboard/finance/home/${company_id}`}
        />
        {userInfo.access_level === ROLE.ADMIN && (
          <>
            <PermissionCard
              title={t("role.admin")}
              icon={<IconWrapper icon={RiAdminFill} size={40} />}
              bgColor="bg-primary-yellowMain"
              to={`/dashboard/admin/home/${company_id}`}
            />
            <PermissionCard
              title={t("role.sbee")}
              icon={<IconWrapper icon={RiShieldUserFill} size={40} />}
              bgColor="bg-primary-yellowMain"
              to={`/sbee`}
            />
          </>
        )}
      </div>

      <p className="text-sm text-gray-500 mt-2 lg:self-end">
        {t("feedback_msg.contact_super_admin")}{" "}
        <Link to="/" className="text-blue-500 underline">
          {t("feedback_msg.contact_super_admin")}
        </Link>
      </p>
    </div>
  );
}

export default UserTypeSwitcher;

const PermissionCard = ({
  title,
  icon,
  bgColor,
  to,
}: {
  title: string;
  icon: any;
  bgColor: string;
  to: string;
}) => (
  <Link
    to={to}
    className={`w-40 h-40 rounded-lg shadow-md flex flex-col items-center justify-center relative text-gray-700 ${bgColor}`}
  >
    {icon}
    <h3 className="mt-4 text-lg font-medium text-gray-700">{title}</h3>
  </Link>
);
